module.exports = __webpack_public_path__ + "static/media/hide-shadow.59660945.svg";